import React from 'react';
import _ from 'underscore';

import { ProfilePictureStyles } from '../styles/ProfilePictureStyles';

export const DEFAULT_PROFILE_TEXT_COLOR = ProfilePictureStyles.Colors.DefaultTextColor;
export const DEFAULT_PROFILE_FILL_COLOR = ProfilePictureStyles.Colors.DefaultFillColor;

export const INVERTED_PROFILE_TEXT_COLOR = ProfilePictureStyles.Colors.DefaultFillColor;
export const INVERTED_PROFILE_FILL_COLOR = ProfilePictureStyles.Colors.DefaultTextColor;

export function ProfilePicture(props: ProfilePicture.Props): JSX.Element {

  const topLevelElementStyles: React.CSSProperties = {
    width: props.sizeInPixels,
    height: props.sizeInPixels,
    borderRadius: props.shape === ProfilePicture.Shape.Circle ? '50%' : '6%'
  };

  if (props.borderWidth && props.borderColor) {
    _.extend(topLevelElementStyles, {
      borderWidth: props.borderWidth,
      borderColor: props.borderColor,
      borderStyle: 'solid'
    });
  }

  if (props.iconNode) {
    return (
      <div style={_.extend({}, topLevelElementStyles, { overflow: 'hidden' })} data-tb-test-id={props.testId}>
        {props.iconNode}
      </div>
    );
  }

  return props.imageUrl?
         ImageUserProfileComponent(topLevelElementStyles, props.imageUrl, props.testId) :
         TextUserProfileComponent(topLevelElementStyles, props.sizeInPixels, props.contentLetters, props.fontSizeInPixels, props.fillColor, props.textColor, props.testId);

}

function ImageUserProfileComponent(topLevelElementStyles: React.CSSProperties, imageUrl: string, testId?: string): JSX.Element {
  return (<img
            data-tb-test-id={testId}
            style={_.extend(topLevelElementStyles, {objectFit: 'cover'})}
            src={imageUrl}
            alt=""
         />);
}

function TextUserProfileComponent(
  topLevelElementStyles: React.CSSProperties,
  sizeInPixels: number, contentLetters: string,
  fontSizeInPixels: number,
  fillColor: string = DEFAULT_PROFILE_FILL_COLOR,
  textColor: string = DEFAULT_PROFILE_TEXT_COLOR,
  testId?: string
): JSX.Element {
  return (
    <svg style={topLevelElementStyles} data-tb-test-id={testId}>
      <rect
        fill={fillColor}
        x="0"
        y="0"
        height="100%"
        width="100%"
      />
      <text
        style = {_.extend({},
          ProfilePictureStyles.TextSelect.DisAbleUserSelect,
          {
            fontWeight: 'normal',
            fill: textColor,
            fontSize: fontSizeInPixels,
            textAnchor: 'middle'
          }
        )}
        x={sizeInPixels/2}
        // size of the character is always 3px lesser than what's declared.
        // align the center of the character with the center of the rect
        y={(sizeInPixels/2) + ((fontSizeInPixels - 3)/2)}>
        {contentLetters}
      </text>
    </svg>
  );
}

export module ProfilePicture {

  export interface Props {
    contentLetters: string;
    imageUrl: string;
    iconNode?: React.ReactNode;
    sizeInPixels: number;
    fontSizeInPixels: number;
    shape: Shape;
    borderWidth?: number;
    borderColor?: string;
    fillColor?: string;
    textColor?: string;
    testId?: string;
  }

  export enum Shape {
    Circle,
    Square
  }

}
